import { Col, Row, Alert, Container, CloseButton } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import React from "react";
import "leaflet-easybutton";
import "@geoman-io/leaflet-geoman-free";
import "@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Form from "react-bootstrap/Form";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Button from "react-bootstrap/Button";
import Doughnut from "./Doughnut.js";
import Bar from "./Bar.js";
import webgisLogo from "./images/webgis.png";

let nuts0Geojson;
let nuts1Geojson;
let nuts2Geojson;
let nuts3Geojson;
let climatesGeojson;

let MapL = (props) => {
  let [polygonHoverName, setPolygonHoverName] = React.useState("");
  let [queryResults, setQueryResults] = React.useState([]);
  let [showMessageFlag, setShowMessageFlag] = React.useState(false);
  let [openQueriesFlag, setOpenQueriesFlag] = React.useState(false);
  let [openDownloadsFlag, setOpenDownloadsFlag] = React.useState(false);
  let history = useHistory();
  let [queryParts, setQueryParts] = React.useState([]);
  let [searchValue, setSearchValue] = React.useState("");
  let [percentQueryParts, setPercentQueryParts] = React.useState([]);
  let [booleanQueryParts, setBooleanQueryParts] = React.useState([true]);
  let [toggle, setToggle] = React.useState(false);
  let [mainA, setMainA] = React.useState(0);
  let [mainB, setMainB] = React.useState(0);
  let [mainC, setMainC] = React.useState(0);
  let [mainD, setMainD] = React.useState(0);
  let [mainE, setMainE] = React.useState(0);
  let [mainF, setMainF] = React.useState(0);
  let [comparedA, setComparedA] = React.useState(0);
  let [comparedB, setComparedB] = React.useState(0);
  let [comparedC, setComparedC] = React.useState(0);
  let [comparedD, setComparedD] = React.useState(0);
  let [comparedE, setComparedE] = React.useState(0);
  let [comparedF, setComparedF] = React.useState(0);
  let [mainCountry, setMainCountry] = React.useState("");
  let [comparedCountry, setComparedCountry] = React.useState("");
  const stateRef = React.useRef(false);
  let [chartVisible, setChartVisible] = React.useState(false);
  let [barChartVisible, setBarChartVisible] = React.useState(false);
  let [doughnutTitle, setDoughnutTitle] = React.useState("World");
  let [typeAnumber, setTypeAnumber] = React.useState(15);
  let [typeBnumber, setTypeBnumber] = React.useState(25);
  let [typeCnumber, setTypeCnumber] = React.useState(45);
  let [typeDnumber, setTypeDnumber] = React.useState(5);
  let [typeEnumber, setTypeEnumber] = React.useState(10);
  let [typeFnumber, setTypeFnumber] = React.useState(12);
  let [mapstate, setMapstate] = React.useState();
  const URL = "d2epc-webgis.geosystems-hellas.gr";
  let L = window.L;

  let toggler = () => {
    if (toggle) setToggle(false);
    else setToggle(true);
  };

  React.useEffect(() => {
    window.openQueriesFlag = false;
    window.levelZeroForQueries = true;
    window.levelOneForQueries = false;
    window.levelTwoForQueries = false;
    window.levelThreeForQueries = false;
    window.climatesForQueries = false;

    const home = {
      lat: 51.505,
      lng: 15.91,
      zoom: 4,
    };

    const CartoDB_Positron = L.tileLayer(
      "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png",
      {
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',

        subdomains: "abcd",

        maxZoom: 20,
      }
    );

    const CartoDB_DarkMatter = L.tileLayer(
      "https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png",
      {
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',

        subdomains: "abcd",

        maxZoom: 20,
      }
    );

    const OpenStreetMap = L.tileLayer(
      "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      {
        maxZoom: 20,
        maxNativeZoom: 19,
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      }
    );

    const HumanitarianMap = L.tileLayer(
      "https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png",
      {
        maxZoom: 20,
        maxNativeZoom: 19,
        attribution:
          "© OpenStreetMap Contributors. Tiles courtesy of Humanitarian OpenStreetMap Teams",
      }
    );

    const TonerMap = L.tileLayer(
      // "http://c.tile.stamen.com/watercolor/${z}/${x}/${y}.jpg",
      "https://stamen-tiles.a.ssl.fastly.net/toner/{z}/{x}/{y}.png",
      {
        maxZoom: 20,
        maxNativeZoom: 19,
        attribution:
          'Map tiles by <a href="http://stamen.com">Stamen Design</a>, under <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a>. Data by <a href="http://openstreetmap.org">OpenStreetMap</a>, under <a href="http://www.openstreetmap.org/copyright">ODbL</a>.',
      }
    );

    const Esri_WorldImagery = L.tileLayer(
      "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
      {
        attribution:
          "Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community",
      }
    );

    if (document.getElementById("mapid")) {
      document.getElementById("mapid")._leaflet_id = null;

      let map = new L.map("mapid", { zoomControl: false, cursor: true });

      window.cleanLayers = function () {
        setChartVisible(false);
        window.previousLayer &&
          window.previousLayer.setStyle({
            //color: "#3388ff",
            fillColor: "#bababa",
            //fillOpacity: 0.2,
          });

        window.comparedLayer &&
          window.comparedLayer.setStyle({
            //color: "#3388ff",
            fillColor: "#bababa",
            //fillOpacity: 0.2,
          });

        window.previousLayer = null;
        window.comparedLayer = null;
        setBarChartVisible(false);
        stateRef.current = false;
        setMainCountry("");
        setMainA(0);
        setMainB(0);
        setMainC(0);
        setMainD(0);
        setMainE(0);
        setMainF(0);
        setComparedCountry("");
        setComparedA(0);
        setComparedB(0);
        setComparedC(0);
        setComparedD(0);
        setComparedE(0);
        setComparedF(0);
        //window.theBtn && window.theBtn.classList.remove("activeComparison");
      };

      window.searchByName = (string, shouldFlyTo) => {
        cleanQueryState();
        cleanQueryLayers();

        if (!stateRef.current) {
          window.previousLayer &&
            window.previousLayer.setStyle({
              //color: "#3388ff",
              fillColor: "#bababa",
              //  fillOpacity: 0.2,
            });

          window.previousLayer = null;
          setChartVisible(false);
        } else {
          window.previousLayer &&
            window.previousLayer.setStyle({
              //color: "#3388ff",
              fillColor: "#bababa",
              //  fillOpacity: 0.2,
            });
          window.comparedLayer &&
            window.comparedLayer.setStyle({
              //color: "#3388ff",
              fillColor: "#bababa",
              //fillOpacity: 0.2,
            });
          window.previousLayer = null;
          window.comparedLayer = null;
          setBarChartVisible(false);
          //window.theBtn.classList.remove("activeComparison");
          stateRef.current = false;
          setMainCountry("");
          setMainA(0);
          setMainB(0);
          setMainC(0);
          setMainD(0);
          setMainE(0);
          setMainF(0);
          setComparedCountry("");
          setComparedA(0);
          setComparedB(0);
          setComparedC(0);
          setComparedD(0);
          setComparedE(0);
          setComparedF(0);
        }

        let layers;

        if (window.levelZeroForQueries) {
          layers = nuts0Geojson.getLayers();
        } else if (window.levelThreeForQueries) {
          layers = nuts3Geojson.getLayers();
        } else if (window.levelOneForQueries) {
          layers = nuts1Geojson.getLayers();
        } else if (window.levelTwoForQueries) {
          layers = nuts2Geojson.getLayers();
        } else if (window.climatesForQueries) {
          layers = climatesGeojson.getLayers();
        }

        let pickedLayer = layers.find(
          (elem) => elem.feature.properties.name_latn === string
        );

        if (pickedLayer) {
          if (shouldFlyTo) {
            let flyToPointBeforeSwap =
              pickedLayer.feature.properties.centroid.coordinates;

            let flyToPoint = [flyToPointBeforeSwap[1], flyToPointBeforeSwap[0]];

            if (window.levelZeroForQueries)
              map.flyTo(flyToPoint, 6, { duration: 1 });
            else map.flyTo(flyToPoint, 8, { duration: 1 });
          }
          setTimeout(() => {
            pickedLayer.setStyle({
              fillColor: "#ca0020",
              //fillOpacity: 0.8,
              //color: "#0000cc",
            });
            pickedLayer.bringToFront();
            window.previousLayer = pickedLayer;

            setDoughnutTitle(pickedLayer.feature.properties.name_latn);

            let y = pickedLayer.feature.properties.name_latn.replaceAll(
              "/",
              ""
            );

            setTypeAnumber(
              Math.round(
                100 *
                  (pickedLayer.feature.properties.a /
                    pickedLayer.feature.properties.total)
              )
            );
            setTypeBnumber(
              Math.round(
                100 *
                  (pickedLayer.feature.properties.b /
                    pickedLayer.feature.properties.total)
              )
            );
            setTypeCnumber(
              Math.round(
                100 *
                  (pickedLayer.feature.properties.c /
                    pickedLayer.feature.properties.total)
              )
            );
            setTypeDnumber(
              Math.round(
                100 *
                  (pickedLayer.feature.properties.d /
                    pickedLayer.feature.properties.total)
              )
            );
            setTypeEnumber(
              Math.round(
                100 *
                  (pickedLayer.feature.properties.e /
                    pickedLayer.feature.properties.total)
              )
            );
            setTypeFnumber(
              Math.round(
                100 *
                  (pickedLayer.feature.properties.f /
                    pickedLayer.feature.properties.total)
              )
            );
            setChartVisible(true);
          }, 1200);
        } else {
          setShowMessageFlag(true);
          setTimeout(() => {
            setShowMessageFlag(false);
          }, 3000);
        }
      };

      window.addNutsLayerDependingOnPickedMode = () => {
        if (window.climatesForQueries) {
          if (map.hasLayer(nuts0Geojson)) {
            map.removeLayer(nuts0Geojson);
          }
          if (map.hasLayer(nuts1Geojson)) {
            map.removeLayer(nuts1Geojson);
          }
          if (map.hasLayer(nuts2Geojson)) {
            map.removeLayer(nuts2Geojson);
          }
          if (map.hasLayer(nuts3Geojson)) {
            map.removeLayer(nuts3Geojson);
          }

          if (!map.hasLayer(climatesGeojson)) {
            map.addLayer(climatesGeojson);
          }
        } else if (window.levelThreeForQueries) {
          if (map.hasLayer(nuts0Geojson)) {
            map.removeLayer(nuts0Geojson);
          }
          if (map.hasLayer(nuts1Geojson)) {
            map.removeLayer(nuts1Geojson);
          }
          if (map.hasLayer(nuts2Geojson)) {
            map.removeLayer(nuts2Geojson);
          }
          if (map.hasLayer(climatesGeojson)) {
            map.removeLayer(climatesGeojson);
          }

          if (!map.hasLayer(nuts3Geojson)) {
            map.addLayer(nuts3Geojson);
          }
        } else if (window.levelZeroForQueries) {
          if (map.hasLayer(nuts3Geojson)) {
            map.removeLayer(nuts3Geojson);
          }
          if (map.hasLayer(nuts1Geojson)) {
            map.removeLayer(nuts1Geojson);
          }
          if (map.hasLayer(nuts2Geojson)) {
            map.removeLayer(nuts2Geojson);
          }
          if (map.hasLayer(climatesGeojson)) {
            map.removeLayer(climatesGeojson);
          }
          if (!map.hasLayer(nuts0Geojson)) {
            map.addLayer(nuts0Geojson);
          }
        } else if (window.levelOneForQueries) {
          if (map.hasLayer(nuts3Geojson)) {
            map.removeLayer(nuts3Geojson);
          }
          if (map.hasLayer(nuts0Geojson)) {
            map.removeLayer(nuts0Geojson);
          }
          if (map.hasLayer(nuts2Geojson)) {
            map.removeLayer(nuts2Geojson);
          }
          if (map.hasLayer(climatesGeojson)) {
            map.removeLayer(climatesGeojson);
          }
          if (!map.hasLayer(nuts1Geojson)) {
            map.addLayer(nuts1Geojson);
          }
        } else if (window.levelTwoForQueries) {
          if (map.hasLayer(nuts3Geojson)) {
            map.removeLayer(nuts3Geojson);
          }
          if (map.hasLayer(nuts0Geojson)) {
            map.removeLayer(nuts0Geojson);
          }
          if (map.hasLayer(nuts1Geojson)) {
            map.removeLayer(nuts1Geojson);
          }
          if (map.hasLayer(climatesGeojson)) {
            map.removeLayer(climatesGeojson);
          }
          if (!map.hasLayer(nuts2Geojson)) {
            map.addLayer(nuts2Geojson);
          }
        }
      };

      window.addNutsLayerDependingOnZoomLevel = () => {
        if (map.getZoom() >= 5) {
          if (map.hasLayer(climatesGeojson)) {
            map.removeLayer(climatesGeojson);
          }
          if (map.hasLayer(nuts0Geojson)) {
            map.removeLayer(nuts0Geojson);
          }
          if (map.hasLayer(nuts2Geojson)) {
            map.removeLayer(nuts2Geojson);
          }
          if (map.hasLayer(nuts3Geojson)) {
            map.removeLayer(nuts3Geojson);
          }

          if (!map.hasLayer(nuts1Geojson)) {
            map.addLayer(nuts1Geojson);
          }
        } else if (map.getZoom() >= 8) {
          if (map.hasLayer(climatesGeojson)) {
            map.removeLayer(climatesGeojson);
          }
          if (map.hasLayer(nuts3Geojson)) {
            map.removeLayer(nuts3Geojson);
          }
          if (map.hasLayer(nuts1Geojson)) {
            map.removeLayer(nuts1Geojson);
          }
          if (map.hasLayer(nuts0Geojson)) {
            map.removeLayer(nuts0Geojson);
          }

          if (!map.hasLayer(nuts2Geojson)) {
            map.addLayer(nuts2Geojson);
          }
        } else if (map.getZoom() >= 10) {
          if (map.hasLayer(climatesGeojson)) {
            map.removeLayer(climatesGeojson);
          }
          if (map.hasLayer(nuts2Geojson)) {
            map.removeLayer(nuts2Geojson);
          }
          if (map.hasLayer(nuts1Geojson)) {
            map.removeLayer(nuts1Geojson);
          }
          if (map.hasLayer(nuts0Geojson)) {
            map.removeLayer(nuts0Geojson);
          }

          if (!map.hasLayer(nuts3Geojson)) {
            map.addLayer(nuts3Geojson);
          }
        } else if (map.getZoom() < 5) {
          if (map.hasLayer(climatesGeojson)) {
            map.removeLayer(climatesGeojson);
          }
          if (map.hasLayer(nuts2Geojson)) {
            map.removeLayer(nuts2Geojson);
          }
          if (map.hasLayer(nuts1Geojson)) {
            map.removeLayer(nuts1Geojson);
          }
          if (map.hasLayer(nuts3Geojson)) {
            map.removeLayer(nuts3Geojson);
          }

          if (!map.hasLayer(nuts0Geojson)) {
            map.addLayer(nuts0Geojson);
          }
        }
      };

      window.pickLevelZeroForQueries = (e) => {
        if (e.target.value == 0) {
          window.climatesForQueries = false;
          window.levelZeroForQueries = true;
          window.levelOneForQueries = false;
          window.levelTwoForQueries = false;
          window.levelThreeForQueries = false;
          if (map.hasLayer(climatesGeojson)) {
            map.removeLayer(climatesGeojson);
          }
          if (map.hasLayer(nuts3Geojson)) {
            map.removeLayer(nuts3Geojson);
          }
          if (map.hasLayer(nuts1Geojson)) {
            map.removeLayer(nuts1Geojson);
          }
          if (map.hasLayer(nuts2Geojson)) {
            map.removeLayer(nuts2Geojson);
          }

          if (!map.hasLayer(nuts0Geojson)) {
            map.addLayer(nuts0Geojson);
          }
        }
      };

      window.pickClimatesForQueries = (e) => {
        if (e.target.value == 4) {
          window.levelZeroForQueries = false;
          window.levelOneForQueries = false;
          window.levelTwoForQueries = false;
          window.levelThreeForQueries = false;
          window.climatesForQueries = true;
          if (map.hasLayer(nuts0Geojson)) {
            map.removeLayer(nuts0Geojson);
          }
          if (map.hasLayer(nuts1Geojson)) {
            map.removeLayer(nuts1Geojson);
          }
          if (map.hasLayer(nuts2Geojson)) {
            map.removeLayer(nuts2Geojson);
          }

          if (map.hasLayer(nuts3Geojson)) {
            map.removeLayer(nuts3Geojson);
          }
          if (!map.hasLayer(climatesGeojson)) {
            map.addLayer(climatesGeojson);
          }
        }
      };

      window.pickLevelThreeForQueries = (e) => {
        if (e.target.value == 3) {
          window.climatesForQueries = false;
          window.levelZeroForQueries = false;
          window.levelOneForQueries = false;
          window.levelTwoForQueries = false;
          window.levelThreeForQueries = true;
          if (map.hasLayer(climatesGeojson)) {
            map.removeLayer(climatesGeojson);
          }
          if (map.hasLayer(nuts0Geojson)) {
            map.removeLayer(nuts0Geojson);
          }
          if (map.hasLayer(nuts1Geojson)) {
            map.removeLayer(nuts1Geojson);
          }
          if (map.hasLayer(nuts2Geojson)) {
            map.removeLayer(nuts2Geojson);
          }

          if (!map.hasLayer(nuts3Geojson)) {
            map.addLayer(nuts3Geojson);
          }
        }
      };

      window.pickLevelOneForQueries = (e) => {
        if (e.target.value == 1) {
          window.climatesForQueries = false;
          window.levelZeroForQueries = false;
          window.levelThreeForQueries = false;
          window.levelOneForQueries = true;
          window.levelTwoForQueries = false;
          if (map.hasLayer(climatesGeojson)) {
            map.removeLayer(climatesGeojson);
          }
          if (map.hasLayer(nuts0Geojson)) {
            map.removeLayer(nuts0Geojson);
          }
          if (map.hasLayer(nuts2Geojson)) {
            map.removeLayer(nuts2Geojson);
          }
          if (map.hasLayer(nuts3Geojson)) {
            map.removeLayer(nuts3Geojson);
          }

          if (!map.hasLayer(nuts1Geojson)) {
            map.addLayer(nuts1Geojson);
          }
        }
      };

      window.pickLevelTwoForQueries = (e) => {
        if (e.target.value == 2) {
          window.climatesForQueries = false;
          window.levelZeroForQueries = false;
          window.levelThreeForQueries = false;
          window.levelOneForQueries = false;
          window.levelTwoForQueries = true;
          if (map.hasLayer(climatesGeojson)) {
            map.removeLayer(climatesGeojson);
          }
          if (map.hasLayer(nuts0Geojson)) {
            map.removeLayer(nuts0Geojson);
          }
          if (map.hasLayer(nuts1Geojson)) {
            map.removeLayer(nuts1Geojson);
          }
          if (map.hasLayer(nuts3Geojson)) {
            map.removeLayer(nuts3Geojson);
          }

          if (!map.hasLayer(nuts2Geojson)) {
            map.addLayer(nuts2Geojson);
          }
        }
      };

      map.on("zoomend", (e) => {
        if (!window.openQueriesFlag) {
          if (map.getZoom() >= 5) {
            if (map.hasLayer(nuts0Geojson)) {
              map.removeLayer(nuts0Geojson);
            }
            if (map.hasLayer(nuts2Geojson)) {
              map.removeLayer(nuts2Geojson);
            }
            if (map.hasLayer(nuts3Geojson)) {
              map.removeLayer(nuts3Geojson);
            }

            if (!map.hasLayer(nuts1Geojson)) {
              map.addLayer(nuts1Geojson);
              window.previousLayer && window.previousLayer.bringToFront();
              window.cleanLayers();
            }
          }
          if (map.getZoom() >= 8) {
            if (map.hasLayer(nuts0Geojson)) {
              map.removeLayer(nuts0Geojson);
            }
            if (map.hasLayer(nuts1Geojson)) {
              map.removeLayer(nuts1Geojson);
            }
            if (map.hasLayer(nuts3Geojson)) {
              map.removeLayer(nuts3Geojson);
            }

            if (!map.hasLayer(nuts2Geojson)) {
              map.addLayer(nuts2Geojson);
              window.previousLayer && window.previousLayer.bringToFront();
              window.cleanLayers();
            }
          }
          if (map.getZoom() >= 10) {
            if (map.hasLayer(nuts0Geojson)) {
              map.removeLayer(nuts0Geojson);
            }
            if (map.hasLayer(nuts2Geojson)) {
              map.removeLayer(nuts2Geojson);
            }
            if (map.hasLayer(nuts1Geojson)) {
              map.removeLayer(nuts1Geojson);
            }

            if (!map.hasLayer(nuts3Geojson)) {
              map.addLayer(nuts3Geojson);
              window.previousLayer && window.previousLayer.bringToFront();
              window.cleanLayers();
            }
          }
          if (map.getZoom() < 5) {
            if (map.hasLayer(nuts3Geojson)) {
              map.removeLayer(nuts3Geojson);
            }
            if (map.hasLayer(nuts2Geojson)) {
              map.removeLayer(nuts2Geojson);
            }
            if (map.hasLayer(nuts1Geojson)) {
              map.removeLayer(nuts1Geojson);
            }

            if (!map.hasLayer(nuts0Geojson) && nuts0Geojson) {
              map.addLayer(nuts0Geojson);
              window.previousLayer && window.previousLayer.bringToFront();
              window.cleanLayers();
            }
          }
        }
      });

      function nutsClickHandler(e) {
        let previous =
          window.queryResults && window.previousLayer
            ? window.queryResults.filter(
                (x) =>
                  x[0] === window.previousLayer.feature.properties.name_latn
              )
            : [];
        let previousC =
          window.queryResults && window.comparedLayer
            ? window.queryResults.filter(
                (x) =>
                  x[0] === window.comparedLayer.feature.properties.name_latn
              )
            : [];
        window.clickFlag = true;

        e.layer.setStyle({
          fillColor: "#ca0020",
          //fillOpacity: 0.8,
          //color: "#0000cc",
        });

        e.layer.bringToFront();

        if (!stateRef.current) {
          if (window.previousLayer !== e.layer) {
            if (previous.length > 0) {
              window.previousLayer &&
                window.previousLayer.setStyle({
                  fillColor: "#404040",
                  fillOpacity: 0.8,
                  //color: "#0000cc",
                });
              window.previousLayer && window.previousLayer.bringToFront();
            } else {
              window.previousLayer &&
                window.previousLayer.setStyle({
                  //color: "#3388ff",
                  fillColor: "#bababa",
                  //fillOpacity: 0.2,
                });
            }

            window.previousLayer = e.layer;
          }
        } else {
          if (window.comparedLayer) {
            let xx = L.stamp(e.layer);

            let yy = L.stamp(window.comparedLayer);

            if (xx !== yy) {
              if (previousC.length > 0) {
                window.comparedLayer &&
                  window.comparedLayer.setStyle({
                    fillColor: "#404040",
                    fillOpacity: 0.8,
                    //color: "#0000cc",
                  });
                window.comparedLayer && window.comparedLayer.bringToFront();
              } else {
                window.comparedLayer &&
                  window.comparedLayer.setStyle({
                    //color: "#3388ff",
                    fillColor: "#bababa",
                    //fillOpacity: 0.2,
                  });
              }
            }
          }
          if (!window.previousLayer) {
            window.previousLayer = e.layer;
            setMainCountry(e.layer.feature.properties.name_latn);
          } else {
            //e.layer.setStyle({ color: "red" });
            e.layer.setStyle({ fillColor: "#f4a582" });
            //e.layer.setStyle({ fillOpacity: 0.45 });
            window.comparedLayer = e.layer;

            setComparedCountry(e.layer.feature.properties.name_latn);
            if (window.previousLayer !== window.comparedlayer) {
              window.previousLayer &&
                window.previousLayer.setStyle({
                  fillColor: "#ca0020",
                  //fillOpacity: 0.8,
                  //  color: "#0000cc",
                });
              window.previousLayer.bringToFront();
            }
          }
        }

        setDoughnutTitle(e.layer.feature.properties.name_latn);

        let x = e.layer.feature.properties.name_latn.replaceAll("/", "");

        if (!stateRef.current) {
          setTypeAnumber(
            Math.round(
              100 *
                (e.layer.feature.properties.a /
                  e.layer.feature.properties.total)
            )
          );
          setTypeBnumber(
            Math.round(
              100 *
                (e.layer.feature.properties.b /
                  e.layer.feature.properties.total)
            )
          );
          setTypeCnumber(
            Math.round(
              100 *
                (e.layer.feature.properties.c /
                  e.layer.feature.properties.total)
            )
          );
          setTypeDnumber(
            Math.round(
              100 *
                (e.layer.feature.properties.d /
                  e.layer.feature.properties.total)
            )
          );
          setTypeEnumber(
            Math.round(
              100 *
                (e.layer.feature.properties.e /
                  e.layer.feature.properties.total)
            )
          );
          setTypeFnumber(
            Math.round(
              100 *
                (e.layer.feature.properties.f /
                  e.layer.feature.properties.total)
            )
          );
          setChartVisible(true);
        } else {
          if (!window.comparedLayer) {
            setMainA(
              Math.round(
                100 *
                  (e.layer.feature.properties.a /
                    e.layer.feature.properties.total)
              )
            );
            setMainB(
              Math.round(
                100 *
                  (e.layer.feature.properties.b /
                    e.layer.feature.properties.total)
              )
            );
            setMainC(
              Math.round(
                100 *
                  (e.layer.feature.properties.c /
                    e.layer.feature.properties.total)
              )
            );
            setMainD(
              Math.round(
                100 *
                  (e.layer.feature.properties.d /
                    e.layer.feature.properties.total)
              )
            );
            setMainE(
              Math.round(
                100 *
                  (e.layer.feature.properties.e /
                    e.layer.feature.properties.total)
              )
            );
            setMainF(
              Math.round(
                100 *
                  (e.layer.feature.properties.f /
                    e.layer.feature.properties.total)
              )
            );
          } else {
            setComparedA(
              Math.round(
                100 *
                  (e.layer.feature.properties.a /
                    e.layer.feature.properties.total)
              )
            );
            setComparedB(
              Math.round(
                100 *
                  (e.layer.feature.properties.b /
                    e.layer.feature.properties.total)
              )
            );
            setComparedC(
              Math.round(
                100 *
                  (e.layer.feature.properties.c /
                    e.layer.feature.properties.total)
              )
            );
            setComparedD(
              Math.round(
                100 *
                  (e.layer.feature.properties.d /
                    e.layer.feature.properties.total)
              )
            );
            setComparedE(
              Math.round(
                100 *
                  (e.layer.feature.properties.e /
                    e.layer.feature.properties.total)
              )
            );
            setComparedF(
              Math.round(
                100 *
                  (e.layer.feature.properties.f /
                    e.layer.feature.properties.total)
              )
            );
          }
        }
      }

      map.setView([home.lat, home.lng], home.zoom, false);

      OpenStreetMap.addTo(map);

      const basemaps = {
        "Open Street Map": OpenStreetMap,
        Humanitarian: HumanitarianMap,
        "Toner Map": TonerMap,
        "Esri World Imagery": Esri_WorldImagery,
        "CartoDB Positron": CartoDB_Positron,
        "CartoDB Dark Matter": CartoDB_DarkMatter,
      };
      //L.control.layers(basemaps, overlaymaps).addTo(map);
      L.control.layers(basemaps).addTo(map);

      L.control.zoom({ position: "topleft" }).addTo(map);

      map.on("click", (e) => {
        if (!window.clickFlag) {
          let previousC =
            window.queryResults && window.comparedLayer
              ? window.queryResults.filter(
                  (x) =>
                    x[0] === window.comparedLayer.feature.properties.name_latn
                )
              : [];
          let previous =
            window.queryResults && window.previousLayer
              ? window.queryResults.filter(
                  (x) =>
                    x[0] === window.previousLayer.feature.properties.name_latn
                )
              : [];

          if (!stateRef.current) {
            if (previous.length > 0) {
              window.previousLayer &&
                window.previousLayer.setStyle({
                  fillColor: "#404040",
                  //fillOpacity: 0.8,
                  //color: "#0000cc",
                });
              window.previousLayer && window.previousLayer.bringToFront();
            } else {
              window.previousLayer &&
                window.previousLayer.setStyle({
                  //color: "#3388ff",
                  fillColor: "#bababa",
                  //fillOpacity: 0.2,
                });
            }
            window.previousLayer = null;
            setChartVisible(false);
          } else {
            if (previous.length > 0) {
              window.previousLayer &&
                window.previousLayer.setStyle({
                  fillColor: "#404040",
                  //fillOpacity: 0.8,
                  //color: "#0000cc",
                });
              window.previousLayer && window.previousLayer.bringToFront();
            } else {
              window.previousLayer &&
                window.previousLayer.setStyle({
                  //color: "#3388ff",
                  fillColor: "#bababa",
                  ///fillOpacity: 0.2,
                });
            }

            if (previousC.length > 0) {
              window.comparedLayer &&
                window.comparedLayer.setStyle({
                  fillColor: "#404040",
                  //fillOpacity: 0.8,
                  //color: "#0000cc",
                });
              window.comparedLayer && window.comparedLayer.bringToFront();
            } else {
              window.comparedLayer &&
                window.comparedLayer.setStyle({
                  //color: "#3388ff",
                  fillColor: "#bababa",
                  //fillOpacity: 0.2,
                });
            }

            window.previousLayer = null;
            window.comparedLayer = null;
            setBarChartVisible(false);
            //window.theBtn.classList.remove("activeComparison");

            stateRef.current = false;
            setMainCountry("");
            setMainA(0);
            setMainB(0);
            setMainC(0);
            setMainD(0);
            setMainE(0);
            setMainF(0);
            setComparedCountry("");
            setComparedA(0);
            setComparedB(0);
            setComparedC(0);
            setComparedD(0);
            setComparedE(0);
            setComparedF(0);
          }
        }
        setSearchValue("");
        window.clickFlag = false;
      });

      L.easyButton(
        "fa-home",
        function (btn, map) {
          map.setView([home.lat, home.lng], home.zoom);
        },
        "Initial View"
      ).addTo(map);

      setMapstate(map);

      function resolveQuery(
        elem,
        percentageQueryParts,
        booleanQueryParts,
        queryParts
      ) {
        let lengthOfParts = queryParts.length;

        let resolveQueryInternal = () => {
          if (queryParts[0] === "A>")
            return (
              100 *
                (elem.feature.properties.a / elem.feature.properties.total) >
              percentageQueryParts[0]
            );
          else if (queryParts[0] === "A<")
            return (
              100 *
                (elem.feature.properties.a / elem.feature.properties.total) <
              percentageQueryParts[0]
            );
          else if (queryParts[0] === "B>")
            return (
              100 *
                (elem.feature.properties.b / elem.feature.properties.total) >
              percentageQueryParts[0]
            );
          else if (queryParts[0] === "B<")
            return (
              100 *
                (elem.feature.properties.b / elem.feature.properties.total) <
              percentageQueryParts[0]
            );
          else if (queryParts[0] === "C>")
            return (
              100 *
                (elem.feature.properties.c / elem.feature.properties.total) >
              percentageQueryParts[0]
            );
          else if (queryParts[0] === "C<")
            return (
              100 *
                (elem.feature.properties.c / elem.feature.properties.total) <
              percentageQueryParts[0]
            );
          else if (queryParts[0] === "D>")
            return (
              100 *
                (elem.feature.properties.d / elem.feature.properties.total) >
              percentageQueryParts[0]
            );
          else if (queryParts[0] === "D<")
            return (
              100 *
                (elem.feature.properties.d / elem.feature.properties.total) <
              percentageQueryParts[0]
            );
          else if (queryParts[0] === "E>")
            return (
              100 *
                (elem.feature.properties.e / elem.feature.properties.total) >
              percentageQueryParts[0]
            );
          else if (queryParts[0] === "E<")
            return (
              100 *
                (elem.feature.properties.e / elem.feature.properties.total) <
              percentageQueryParts[0]
            );
          else if (queryParts[0] === "F>")
            return (
              100 *
                (elem.feature.properties.f / elem.feature.properties.total) >
              percentageQueryParts[0]
            );
          else if (queryParts[0] === "F<")
            return (
              100 *
                (elem.feature.properties.f / elem.feature.properties.total) <
              percentageQueryParts[0]
            );
        };
        if (lengthOfParts > 1) {
          if (booleanQueryParts[1])
            return (
              resolveQueryInternal() &&
              resolveQuery(
                elem,
                percentageQueryParts.slice(1, lengthOfParts),
                booleanQueryParts.slice(1, lengthOfParts),
                queryParts.slice(1, lengthOfParts)
              )
            );
          else
            return (
              resolveQueryInternal() ||
              resolveQuery(
                elem,
                percentageQueryParts.slice(1, lengthOfParts),
                booleanQueryParts.slice(1, lengthOfParts),
                queryParts.slice(1, lengthOfParts)
              )
            );
        } else return resolveQueryInternal();
      }

      window.setQueryLayers = (
        e,
        percentQueryParts,
        booleanQueryParts,
        queryParts
      ) => {
        cleanQueryLayers();

        if (!stateRef.current) {
          window.previousLayer &&
            window.previousLayer.setStyle({
              //color: "#3388ff",
              fillColor: "#bababa",
              //fillOpacity: 0.2,
            });

          window.previousLayer = null;
          setChartVisible(false);
        } else {
          window.previousLayer &&
            window.previousLayer.setStyle({
              //color: "#3388ff",
              fillColor: "#bababa",
              //fillOpacity: 0.2,
            });
          window.comparedLayer &&
            window.comparedLayer.setStyle({
              //color: "#3388ff",
              fillColor: "#bababa",
              //fillOpacity: 0.2,
            });
          window.previousLayer = null;
          window.comparedLayer = null;
          setBarChartVisible(false);
          //window.theBtn.classList.remove("activeComparison");
          stateRef.current = false;
          setMainCountry("");
          setMainA(0);
          setMainB(0);
          setMainC(0);
          setMainD(0);
          setMainE(0);
          setMainF(0);
          setComparedCountry("");
          setComparedA(0);
          setComparedB(0);
          setComparedC(0);
          setComparedD(0);
          setComparedE(0);
          setComparedF(0);
        }

        let layers;
        if (window.levelZeroForQueries) layers = nuts0Geojson.getLayers();
        else if (window.levelOneForQueries) layers = nuts1Geojson.getLayers();
        else if (window.levelTwoForQueries) layers = nuts2Geojson.getLayers();
        else if (window.levelThreeForQueries) layers = nuts3Geojson.getLayers();
        else if (window.climatesForQueries)
          layers = climatesGeojson.getLayers();

        let pickedLayers = layers.filter((elem) => {
          return resolveQuery(
            elem,
            percentQueryParts,
            booleanQueryParts,
            queryParts
          );
        });

        if (pickedLayers.length !== 0) {
          pickedLayers.map((k) => {
            k.setStyle({
              fillColor: "#404040",
              //fillOpacity: 0.8,
              //color: "#0000cc",
            });
            k.bringToFront();
          });
          window.queryLayers = pickedLayers;

          let pickedLayersResult = pickedLayers.map((r) => {
            return [
              r.feature.properties.name_latn,
              (r.feature.properties.a / r.feature.properties.total).toFixed(2),
              (r.feature.properties.b / r.feature.properties.total).toFixed(2),
              (r.feature.properties.c / r.feature.properties.total).toFixed(2),
              (r.feature.properties.d / r.feature.properties.total).toFixed(2),
              (r.feature.properties.e / r.feature.properties.total).toFixed(2),
              (r.feature.properties.f / r.feature.properties.total).toFixed(2),
            ];
          });
          setQueryResults(pickedLayersResult);
          window.queryResults = pickedLayersResult;
        } else {
          setShowMessageFlag(true);
          setTimeout(() => {
            setShowMessageFlag(false);
          }, 3000);
        }
      };

      axios
        .get("/getClimates")
        .then(function (response) {
          climatesGeojson = L.geoJSON(response.data, {
            style: (lay) => {
              return {
                fillColor: "#bababa",
                fillOpacity: 0.5,
                color: "black",
                weight: 2,
              };
            },
          });

          //climatesGeojson.addTo(map);

          climatesGeojson.on("mouseover", (e) => {
            setPolygonHoverName(e.layer.feature.properties.name_latn);
          });
          climatesGeojson.on("mouseout", (e) => {
            setPolygonHoverName("");
          });
          climatesGeojson.on("click", nutsClickHandler);
        })
        .catch((e) => {
          console.log("error");
        });

      axios
        .get("/getWFS_NUTSLevel/0")
        .then(function (response) {
          nuts0Geojson = L.geoJSON(response.data, {
            style: (lay) => {
              return {
                fillColor: "#bababa",
                fillOpacity: 0.5,
                color: "black",
                weight: 2,
              };
            },
          });

          nuts0Geojson.addTo(map);

          nuts0Geojson.on("mouseover", (e) => {
            setPolygonHoverName(e.layer.feature.properties.name_latn);
          });
          nuts0Geojson.on("mouseout", (e) => {
            setPolygonHoverName("");
          });
          nuts0Geojson.on("click", nutsClickHandler);
        })
        .catch((e) => {
          console.log("error");
        });

      axios.get("/getWFS_NUTSLevel/3").then((response) => {
        nuts3Geojson = L.geoJSON(response.data, {
          style: (lay) => {
            return {
              fillColor: "#bababa",
              fillOpacity: 0.5,
              color: "black",
              weight: 2,
            };
          },
        });

        nuts3Geojson.on("mouseover", (e) => {
          setPolygonHoverName(e.layer.feature.properties.name_latn);
        });
        nuts3Geojson.on("mouseout", (e) => {
          setPolygonHoverName("");
        });
        nuts3Geojson.on("click", nutsClickHandler);
      });

      axios.get("/getWFS_NUTSLevel/2").then((response) => {
        nuts2Geojson = L.geoJSON(response.data, {
          style: (lay) => {
            return {
              fillColor: "#bababa",
              fillOpacity: 0.5,
              color: "black",
              weight: 2,
            };
          },
        });
        nuts2Geojson.on("mouseover", (e) => {
          setPolygonHoverName(e.layer.feature.properties.name_latn);
        });
        nuts2Geojson.on("mouseout", (e) => {
          setPolygonHoverName("");
        });
        nuts2Geojson.on("click", nutsClickHandler);
      });

      axios.get("/getWFS_NUTSLevel/1").then((response) => {
        nuts1Geojson = L.geoJSON(response.data, {
          style: (lay) => {
            return {
              fillColor: "#bababa",
              fillOpacity: 0.5,
              color: "black",
              weight: 2,
            };
          },
        });
        nuts1Geojson.on("mouseover", (e) => {
          setPolygonHoverName(e.layer.feature.properties.name_latn);
        });
        nuts1Geojson.on("mouseout", (e) => {
          setPolygonHoverName("");
        });
        nuts1Geojson.on("click", nutsClickHandler);
      });
    }
  }, []);

  let markerone = L.marker([40.56684065583539, 22.99914141984516]);
  let markertwo = L.marker([52.69416313279648, 13.17619079471821]);
  let markerthree = L.marker([52.57824658520175, 13.30984223297508]);
  let markerfour = L.marker([35.1795402215509, 33.37951660740866]);
  let markerfive = L.marker([52.57401969133613, 13.42022988350698]);
  let markersix = L.marker([52.47861288878715, 13.44758837881122]);

  let deciderFunc = (queryParts) => {
    let res = new Set();
    for (let i = 0; i < queryParts.length; i++) {
      if (queryParts[i][0] === "A") res.add("A");
      else if (queryParts[i][0] === "B") res.add("B");
      else if (queryParts[i][0] === "B") res.add("B");
      else if (queryParts[i][0] === "C") res.add("C");
      else if (queryParts[i][0] === "D") res.add("D");
      else if (queryParts[i][0] === "E") res.add("E");
      else if (queryParts[i][0] === "F") res.add("F");
    }
    return res;
  };

  let cleanQueryLayers = () => {
    if (window.queryLayers) {
      window.queryLayers.map((k) => {
        k.setStyle({
          //color: "#3388ff",
          fillColor: "#bababa",
          //fillOpacity: 0.2,
        });
      });
    }
    window.queryLayers = [];
    setQueryResults([]);
    window.queryResults = null;
  };

  let cleanQueryState = () => {
    setBooleanQueryParts([true]);
    setPercentQueryParts([]);
    setQueryParts([]);
  };

  let activeQueryParts = deciderFunc(queryParts);
  let percents = (r) =>
    (activeQueryParts.has("A") ? Math.trunc(r[1] * 100) + "%, " : "") +
    (activeQueryParts.has("B") ? Math.trunc(r[2] * 100) + "%, " : "") +
    (activeQueryParts.has("C") ? Math.trunc(r[3] * 100) + "%, " : "") +
    (activeQueryParts.has("D") ? Math.trunc(r[4] * 100) + "%, " : "") +
    (activeQueryParts.has("E") ? Math.trunc(r[5] * 100) + "%, " : "") +
    (activeQueryParts.has("F") ? Math.trunc(r[6] * 100) + "%, " : "");

  let epcList =
    (activeQueryParts.has("A") ? "A, " : "") +
    (activeQueryParts.has("B") ? "B, " : "") +
    (activeQueryParts.has("C") ? "C, " : "") +
    (activeQueryParts.has("D") ? "D, " : "") +
    (activeQueryParts.has("E") ? "E, " : "") +
    (activeQueryParts.has("F") ? "F, " : "");

  let resolveSearchPlaceholder = () => {
    if (window.levelZeroForQueries) return "Countries";
    else if (window.levelOneForQueries) return "Major Regions";
    else if (window.levelTwoForQueries) return "Basic Regions";
    else if (window.levelThreeForQueries) return "Small Regions";
    else if (window.climatesForQueries) return "Climate Zones";
  };

  function clickListener() {
    let previous =
      window.queryResults && window.previousLayer
        ? window.queryResults.filter(
            (x) => x[0] === window.previousLayer.feature.properties.name_latn
          )
        : [];

    if (stateRef.current) {
      let previousC =
        window.queryResults && window.comparedLayer
          ? window.queryResults.filter(
              (x) => x[0] === window.comparedLayer.feature.properties.name_latn
            )
          : [];

      //  btn.getContainer().classList.remove("activeComparison");
      setBarChartVisible(false);

      if (previous.length > 0) {
        window.previousLayer &&
          window.previousLayer.setStyle({
            fillColor: "#404040",
            //fillOpacity: 0.8,
            //color: "#0000cc",
          });
        window.previousLayer && window.previousLayer.bringToFront();
      } else {
        window.previousLayer &&
          window.previousLayer.setStyle({
            //color: "#3388ff",
            fillColor: "#bababa",
            //fillOpacity: 0.2,
          });
      }

      if (previousC.length > 0) {
        window.comparedLayer &&
          window.comparedLayer.setStyle({
            fillColor: "#404040",
            //fillOpacity: 0.8,
            //color: "#0000cc",
          });
        window.comparedLayer && window.comparedLayer.bringToFront();
      } else {
        window.comparedLayer &&
          window.comparedLayer.setStyle({
            //color: "#3388ff",
            fillColor: "#bababa",
            //fillOpacity: 0.2,
          });
      }
      window.previousLayer = null;
      window.comparedLayer = null;
      stateRef.current = false;
      setMainCountry("");
      setMainA(0);
      setMainB(0);
      setMainC(0);
      setMainD(0);
      setMainE(0);
      setMainF(0);
      setComparedCountry("");
      setComparedA(0);
      setComparedB(0);
      setComparedC(0);
      setComparedD(0);
      setComparedE(0);
      setComparedF(0);
    } else {
      if (previous.length > 0) {
        window.previousLayer &&
          window.previousLayer.setStyle({
            fillColor: "#404040",
            //fillOpacity: 0.8,
            //color: "#0000cc",
          });
        window.previousLayer && window.previousLayer.bringToFront();
      } else {
        window.previousLayer &&
          window.previousLayer.setStyle({
            //color: "#3388ff",
            fillColor: "#bababa",
            //fillOpacity: 0.2,
          });
      }
      setChartVisible(false);
      window.previousLayer = null;
      //  window.theBtn = btn.getContainer();
      //btn.getContainer().classList.add("activeComparison");
      setBarChartVisible(true);
      stateRef.current = true;
    }
  }

  return (
    <div id="mapMainContainer" style={{ position: "relative" }}>
      {showMessageFlag ? (
        <Container fluid id="messageContainer">
          <Row>
            <Col xs={1} sm={4}>
              {" "}
            </Col>
            <Col xs={10} sm={4}>
              <Alert
                dismissible
                onClose={() => {
                  setShowMessageFlag(false);
                }}
                className="mx-auto"
                id="resultsMessage"
                variant="success"
              >
                No results.
              </Alert>
            </Col>
            <Col xs={1} sm={4}>
              {" "}
            </Col>
          </Row>
        </Container>
      ) : null}

      <Container fluid>
        <Row
          style={{
            height: "4rem",
            background: "linear-gradient(-180deg, #b3b3b3, #ebebeb)",
          }}
        >
          <Col
            xs={1}
            style={{ background: "linear-gradient(-180deg, #cccccc, #ebebeb)" }}
          >
            {" "}
          </Col>

          <Col
            xs={2}
            style={{
              lineHeight: "4rem",
              background: "linear-gradient(-180deg, #cccccc, #ebebeb)",
            }}
          >
            <img src={webgisLogo} style={{ height: "3rem" }} />
          </Col>
          <Col
            xs={1}
            style={{ background: "linear-gradient(-180deg, #cccccc, #ebebeb)" }}
          >
            {" "}
          </Col>
          <Col
            xs={4}
            style={{
              background: "linear-gradient(-180deg, #b3b3b3, #ebebeb)",
              textAlign: "center",
              lineHeight: "4rem",
              color: "DarkGray",
            }}
          >
            {polygonHoverName}
          </Col>

          <Col
            xs={4}
            style={{
              background: "linear-gradient(-180deg, #cccccc, #ebebeb)",
              direction: "rtl",

              lineHeight: "1rem",
            }}
          >
            <div
              style={{ marginTop: "10px", color: "#8c8c8c", fontSize: "11px" }}
            >
              &nbsp; &nbsp; &nbsp; Last update: Sat Feb 26, 2022 🕔 1:45pm{" "}
              <br /> &nbsp; &nbsp; &nbsp; Total dEPCs issued: 536
            </div>
          </Col>
        </Row>
      </Container>

      <Container
        fluid
        style={{ height: "100%", padding: 0, overflow: "hidden" }}
      >
        <Row style={{ height: "100%", padding: 0 }}>
          <Col
            xs="auto"
            style={{
              width: "4rem",
              height: "100%",
              background: "linear-gradient(-180deg, #cccccc, #ebebeb)",
            }}
          >
            <OverlayTrigger
              placement={"bottom"}
              overlay={
                <Tooltip id={`tooltip-1`} style={{ zIndex: 190000 }}>
                  <strong>Queries</strong>
                </Tooltip>
              }
            >
              <Button
                className="actionBarButton"
                onClick={() => {
                  window.cleanLayers();
                  setOpenQueriesFlag(true);
                  setOpenDownloadsFlag(false);
                  window.openQueriesFlag = true;
                  window.addNutsLayerDependingOnPickedMode();
                }}
              >
                <i class="fa fa-search"></i>
              </Button>
            </OverlayTrigger>

            <Dropdown className="d-inline" drop="end">
              <OverlayTrigger
                placement={"bottom"}
                overlay={
                  <Tooltip id={`tooltip-1`} style={{ zIndex: 190000 }}>
                    <strong>Pilot Cases</strong>
                  </Tooltip>
                }
              >
                <Dropdown.Toggle className="actionBarButton">
                  <i class="material-icons">apartment</i>
                </Dropdown.Toggle>
              </OverlayTrigger>
              <Dropdown.Menu
                style={{
                  color: "gray",
                  backgroundColor: "gray",
                  width: "300px",
                  zIndex: 148000,
                }}
              >
                <Dropdown.Item
                  onClick={(e) => {
                    markertwo.removeFrom(mapstate);
                    markerfour.removeFrom(mapstate);
                    markerthree.removeFrom(mapstate);
                    markerfive.removeFrom(mapstate);
                    markersix.removeFrom(mapstate);
                    markerone.addTo(mapstate);
                    markerone.on("click", () => {
                      history.push("/pilotcase1");
                    });
                    mapstate.flyTo(
                      [40.56684065583539, 22.99914141984516],
                      9,
                      false
                    );
                  }}
                >
                  Smart House in Thessaloniki
                </Dropdown.Item>

                <Dropdown.Item
                  onClick={() => {
                    markerone.removeFrom(mapstate);
                    markerfour.removeFrom(mapstate);
                    markerthree.removeFrom(mapstate);
                    markerfive.removeFrom(mapstate);
                    markersix.removeFrom(mapstate);
                    markertwo.addTo(mapstate);
                    markertwo.on("click", () => {
                      history.push("/pilotcase2");
                    });
                    mapstate.flyTo(
                      [52.69416313279648, 13.17619079471821],
                      9,
                      false
                    );
                  }}
                >
                  Residential Building in Velten
                </Dropdown.Item>

                <Dropdown.Item
                  onClick={() => {
                    markerone.removeFrom(mapstate);
                    markerthree.removeFrom(mapstate);
                    markertwo.removeFrom(mapstate);
                    markerfive.removeFrom(mapstate);
                    markersix.removeFrom(mapstate);
                    markerthree.addTo(mapstate);
                    markerthree.on("click", () => {
                      history.push("/pilotcase3");
                    });
                    mapstate.flyTo(
                      [52.57824658520175, 13.30984223297508],
                      9,
                      false
                    );
                  }}
                >
                  Tertiary Building in Berlin
                </Dropdown.Item>

                <Dropdown.Item
                  onClick={() => {
                    markerone.removeFrom(mapstate);
                    markerthree.removeFrom(mapstate);
                    markertwo.removeFrom(mapstate);
                    markerfive.removeFrom(mapstate);
                    markersix.removeFrom(mapstate);
                    markerfour.addTo(mapstate);
                    markerfour.on("click", () => {
                      history.push("/pilotcase4");
                    });
                    mapstate.flyTo(
                      [35.1795402215509, 33.37951660740866],
                      9,
                      false
                    );
                  }}
                >
                  Mixed-use Building in Nicosia
                </Dropdown.Item>

                <Dropdown.Item
                  onClick={() => {
                    markerone.removeFrom(mapstate);
                    markerthree.removeFrom(mapstate);
                    markertwo.removeFrom(mapstate);
                    markerfour.removeFrom(mapstate);
                    markerfive.removeFrom(mapstate);
                    markersix.removeFrom(mapstate);
                    markerfive.addTo(mapstate);
                    markerfive.on("click", () => {
                      history.push("/pilotcase5");
                    });
                    mapstate.flyTo(
                      [52.57401969133613, 13.42022988350698],
                      9,
                      false
                    );
                  }}
                >
                  #5 Multi-family home in Berlin
                </Dropdown.Item>

                <Dropdown.Item
                  onClick={() => {
                    markerone.removeFrom(mapstate);
                    markerthree.removeFrom(mapstate);
                    markertwo.removeFrom(mapstate);
                    markerfive.removeFrom(mapstate);
                    markerfour.removeFrom(mapstate);
                    markersix.addTo(mapstate);
                    markersix.on("click", () => {
                      history.push("/pilotcase6");
                    });
                    mapstate.flyTo(
                      [52.47861288878715, 13.44758837881122],
                      9,
                      false
                    );
                  }}
                >
                  #6 Multi-family home in Berlin
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            <OverlayTrigger
              placement={"right"}
              overlay={
                <Tooltip id={`tooltip-d`} style={{ zIndex: 190000 }}>
                  <strong>Comparison Mode</strong>
                </Tooltip>
              }
            >
              <Button
                className="actionBarButton"
                onClick={() => {
                  clickListener();
                }}
              >
                <i class="material-icons">align_vertical_bottom</i>
              </Button>
            </OverlayTrigger>

            <OverlayTrigger
              placement={"bottom"}
              overlay={
                <Tooltip id={`tooltip-d`} style={{ zIndex: 190000 }}>
                  <strong>Downloads Links</strong>
                </Tooltip>
              }
            >
              <Button
                onClick={(e) => {
                  if (openQueriesFlag) {
                    window.cleanLayers();
                    cleanQueryLayers();
                    setQueryParts([]);
                    setOpenQueriesFlag(false);
                    window.openQueriesFlag = false;
                    window.addNutsLayerDependingOnZoomLevel();
                    window.levelZeroForQueries = true;
                    window.levelThreeForQueries = false;
                    window.levelOneForQueries = false;
                    window.levelTwoForQueries = false;
                    setSearchValue("");
                  }
                  setOpenDownloadsFlag(true);
                }}
                className="actionBarButton"
              >
                <i class="fa fa-download"></i>
              </Button>
            </OverlayTrigger>

            <OverlayTrigger
              placement={"bottom"}
              overlay={
                <Tooltip id={`tooltip-d`} style={{ zIndex: 190000 }}>
                  <strong>Information about the webGIS</strong>
                </Tooltip>
              }
            >
              <Button className="actionBarButton">
                <i class="fa fa-info"></i>
              </Button>
            </OverlayTrigger>

            <OverlayTrigger
              placement={"bottom"}
              overlay={
                <Tooltip id={`tooltip-d`} style={{ zIndex: 190000 }}>
                  <strong>Send feedback</strong>
                </Tooltip>
              }
            >
              <Button className="actionBarButton">
                <a
                  href="mailto:mail@geosystems-hellas.gr"
                  style={{ color: "inherit" }}
                >
                  {" "}
                  <i class="fa fa-envelope"></i>{" "}
                </a>
              </Button>
            </OverlayTrigger>
          </Col>

          <Col className="flex-grow-1" style={{ height: "100%", padding: 0 }}>
            <Row
              style={{
                height: "100%",
                margin: 0,
                padding: 0,
                backgroundColor: "Crimson",
                overflow: "hidden",
              }}
            >
              {!openQueriesFlag && !openDownloadsFlag ? (
                <Col xs={12} className="h-100 p-0">
                  <div id="mapid" className="h-100"></div>
                </Col>
              ) : (
                <React.Fragment>
                  <Col xs={{ order: 2, span: 9 }} className="h-100 p-0">
                    <div id="mapid" className="h-100"></div>
                  </Col>
                  {openQueriesFlag ? (
                    <Col
                      xs={{ order: 1, span: 3 }}
                      style={{
                        zIndex: 50000,
                        height: "100%",
                        borderLeft: "solid 4px #404040",
                        background: "linear-gradient(45deg, #cccccc, #ebebeb)",
                        overflowY: "auto",
                        overflowX: "hidden",
                        padding: 0,
                        margin: 0,
                      }}
                    >
                      <Container fluid style={{ padding: 0 }}>
                        <Row>
                          <Col xs={10} align="center"></Col>
                          <Col xs={2} align="center">
                            {" "}
                            <CloseButton
                              onClick={() => {
                                window.cleanLayers();
                                cleanQueryLayers();
                                setQueryParts([]);
                                setOpenQueriesFlag(false);
                                window.openQueriesFlag = false;
                                window.addNutsLayerDependingOnZoomLevel();
                                window.levelZeroForQueries = true;
                                window.levelThreeForQueries = false;
                                window.levelOneForQueries = false;
                                window.levelTwoForQueries = false;
                                window.climatesForQueries = false;
                                setSearchValue("");
                                setTimeout(() => {
                                  mapstate.invalidateSize(true);
                                }, 0);
                              }}
                            />{" "}
                          </Col>
                        </Row>
                        <Row style={{ height: "3vh" }}> </Row>
                        <Row>
                          {" "}
                          <Col
                            xs={12}
                            style={{ textAlign: "center", color: "#8c8c8c" }}
                          >
                            {" "}
                            <u> Choose NUTS Level </u>{" "}
                          </Col>{" "}
                        </Row>
                        <Row style={{ height: "1vh" }}> </Row>
                        <Row style={{}}>
                          <Col xs={2}> </Col>
                          <Col xs={8}>
                            <Form.Select
                              style={{
                                backgroundColor: "DarkGray",
                                color: "#8c8c8c",
                              }}
                              onChange={(e) => {
                                cleanQueryLayers();
                                window.cleanLayers();
                                if (e.target.value == 0) {
                                  window.pickLevelZeroForQueries(e);
                                } else if (e.target.value == 1)
                                  window.pickLevelOneForQueries(e);
                                else if (e.target.value == 2)
                                  window.pickLevelTwoForQueries(e);
                                else if (e.target.value == 3)
                                  window.pickLevelThreeForQueries(e);
                                else if (e.target.value == 4)
                                  window.pickClimatesForQueries(e);

                                toggler();
                              }}
                            >
                              <option value="0">NUTS Level 0</option>
                              <option value="1">NUTS Level 1</option>
                              <option value="2">NUTS Level 2</option>
                              <option value="3">NUTS Level 3</option>
                              <option value="4">Climate Zones</option>
                            </Form.Select>
                          </Col>
                          <Col xs={2}> </Col>
                        </Row>

                        <Row style={{ height: "3vh" }}> </Row>
                        <Row>
                          <Col xs={1}> </Col>
                          <Col xs={10}>
                            <Dropdown.Divider />
                          </Col>
                          <Col xs={1}> </Col>
                        </Row>
                        <Row>
                          {" "}
                          <Col
                            xs={12}
                            style={{ textAlign: "center", color: "#8c8c8c" }}
                          >
                            {" "}
                            <u> Search by Name</u>{" "}
                          </Col>{" "}
                        </Row>
                        <Row style={{ height: "1vh" }}> </Row>
                        <Row>
                          <Col xs={1}> </Col>
                          <Col xs={2}>
                            <button
                              onClick={(e) => {
                                window.searchByName(searchValue, true);
                              }}
                              id="searchValueContainer"
                              style={{
                                border: "solid 6px #595959",
                                backgroundColor: "DarkGreen",
                                borderRadius: "50%",
                                height: "2.5rem",
                                width: "2.5rem",
                                margin: "5px",
                                color: "DarkGray",
                              }}
                            >
                              <i class="fa fa-search"></i>
                            </button>
                          </Col>
                          <Col xs={8}>
                            <Form.Control
                              id="searchValueBox"
                              value={searchValue}
                              onChange={(e) => {
                                window.cleanLayers();
                                setSearchValue(e.target.value);
                              }}
                              style={{
                                border: "solid 6px #595959",
                                backgroundColor: "DarkGray",
                                color: "#404040",
                                fontFamily: "Arial, FontAwesome",
                              }}
                              type="text"
                              placeholder={`Search ${resolveSearchPlaceholder()}..`}
                            />
                          </Col>
                          <Col xs={1}> </Col>
                        </Row>
                        <Row style={{ height: "3vh" }}> </Row>
                        <Row>
                          <Col xs={1}> </Col>
                          <Col xs={10}>
                            <Dropdown.Divider />
                          </Col>
                          <Col xs={1}> </Col>
                        </Row>
                        <Row>
                          {" "}
                          <Col
                            xs={12}
                            style={{ textAlign: "center", color: "#8c8c8c" }}
                          >
                            {" "}
                            <u> Search by EPC Condition</u>{" "}
                          </Col>{" "}
                        </Row>
                        <Row style={{ height: "1vh" }}> </Row>
                        <Row>
                          <Col xs={2}> </Col>
                          <Col xs={8} align="center">
                            <Dropdown
                              drop="bottom"
                              id="dropdown-basic-button"
                              title="Add Condition"
                              menuVariant="dark"
                            >
                              <Dropdown.Toggle
                                drop="bottom"
                                style={{
                                  borderColor: "black",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                  backgroundColor: "#006622",
                                  color: "DarkGray",
                                  width: "10rem",
                                }}
                              >
                                Add Condition&nbsp;&nbsp;
                              </Dropdown.Toggle>
                              <Dropdown.Menu
                                drop="end"
                                style={{
                                  zIndex: 190000,
                                  fontSize: "12px",
                                  backgroundColor: "DarkGray",
                                  overflow: "scroll",
                                  width: "10rem",
                                }}
                              >
                                <Dropdown.Item
                                  onSelect={(ek, e) => {
                                    queryParts.push("A>");
                                    let yy = new Array(queryParts)[0];
                                    setQueryParts(yy);
                                    setQueryResults([]);
                                    cleanQueryLayers();
                                    window.cleanLayers();
                                    toggler();
                                  }}
                                >
                                  A&ge;
                                </Dropdown.Item>
                                <Dropdown.Item
                                  onSelect={(ek, e) => {
                                    queryParts.push("A<");
                                    let yy = new Array(queryParts)[0];
                                    setQueryParts(yy);
                                    setQueryResults([]);
                                    cleanQueryLayers();
                                    window.cleanLayers();
                                    toggler();
                                  }}
                                >
                                  A&le;
                                </Dropdown.Item>
                                <Dropdown.Item
                                  onSelect={(ek, e) => {
                                    queryParts.push("B>");
                                    let yy = new Array(queryParts)[0];
                                    setQueryParts(yy);
                                    setQueryResults([]);
                                    cleanQueryLayers();
                                    window.cleanLayers();
                                    toggler();
                                  }}
                                >
                                  B&ge;
                                </Dropdown.Item>
                                <Dropdown.Item
                                  onSelect={(ek, e) => {
                                    queryParts.push("B<");
                                    let yy = new Array(queryParts)[0];
                                    setQueryParts(yy);
                                    setQueryResults([]);
                                    cleanQueryLayers();
                                    window.cleanLayers();
                                    toggler();
                                  }}
                                >
                                  B&le;
                                </Dropdown.Item>
                                <Dropdown.Item
                                  onSelect={(ek, e) => {
                                    queryParts.push("C>");
                                    let yy = new Array(queryParts)[0];
                                    setQueryParts(yy);
                                    setQueryResults([]);
                                    cleanQueryLayers();
                                    window.cleanLayers();
                                    toggler();
                                  }}
                                >
                                  C&ge;
                                </Dropdown.Item>
                                <Dropdown.Item
                                  onSelect={(ek, e) => {
                                    queryParts.push("C<");
                                    let yy = new Array(queryParts)[0];
                                    setQueryParts(yy);
                                    setQueryResults([]);
                                    cleanQueryLayers();
                                    window.cleanLayers();
                                    toggler();
                                  }}
                                >
                                  C&le;
                                </Dropdown.Item>
                                <Dropdown.Item
                                  onSelect={(ek, e) => {
                                    queryParts.push("D>");
                                    let yy = new Array(queryParts)[0];
                                    setQueryParts(yy);
                                    setQueryResults([]);
                                    cleanQueryLayers();
                                    window.cleanLayers();
                                    toggler();
                                  }}
                                >
                                  D&ge;
                                </Dropdown.Item>
                                <Dropdown.Item
                                  onSelect={(ek, e) => {
                                    queryParts.push("D<");
                                    let yy = new Array(queryParts)[0];
                                    setQueryParts(yy);
                                    setQueryResults([]);
                                    cleanQueryLayers();
                                    window.cleanLayers();
                                    toggler();
                                  }}
                                >
                                  D&le;
                                </Dropdown.Item>
                                <Dropdown.Item
                                  onSelect={(ek, e) => {
                                    queryParts.push("E>");
                                    let yy = new Array(queryParts)[0];
                                    setQueryParts(yy);
                                    setQueryResults([]);
                                    cleanQueryLayers();
                                    window.cleanLayers();
                                    toggler();
                                  }}
                                >
                                  E&ge;
                                </Dropdown.Item>
                                <Dropdown.Item
                                  onSelect={(ek, e) => {
                                    queryParts.push("E<");
                                    let yy = new Array(queryParts)[0];
                                    setQueryParts(yy);
                                    setQueryResults([]);
                                    cleanQueryLayers();
                                    window.cleanLayers();
                                    toggler();
                                  }}
                                >
                                  E&le;
                                </Dropdown.Item>
                                <Dropdown.Item
                                  onSelect={(ek, e) => {
                                    queryParts.push("F>");
                                    let yy = new Array(queryParts)[0];
                                    setQueryParts(yy);
                                    cleanQueryLayers();
                                    window.cleanLayers();
                                    toggler();
                                  }}
                                >
                                  F&ge;
                                </Dropdown.Item>
                                <Dropdown.Item
                                  onSelect={(ek, e) => {
                                    queryParts.push("F<");
                                    let yy = new Array(queryParts)[0];
                                    setQueryParts(yy);
                                    cleanQueryLayers();
                                    window.cleanLayers();
                                    toggler();
                                  }}
                                >
                                  F&le;
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </Col>
                          <Col xs={2} align="center">
                            {" "}
                            <CloseButton
                              onClick={() => {
                                cleanQueryLayers();
                                setQueryParts([]);
                                setBooleanQueryParts([true]);
                                setPercentQueryParts([]);
                                setQueryParts([]);
                                window.cleanLayers();
                                toggler();
                              }}
                            />{" "}
                          </Col>
                        </Row>
                        <Row style={{ height: "2vh" }}> </Row>
                        <Container fluid style={{ height: "0px", padding: 0 }}>
                          {queryParts.map((val, idx) => {
                            if (!percentQueryParts[idx])
                              percentQueryParts[idx] = 50;
                            if (idx === 0) booleanQueryParts[idx] = true;
                            else if (!booleanQueryParts[idx])
                              booleanQueryParts[idx] = false;
                            return (
                              <Row>
                                <Col xs={3}>
                                  {idx !== 0 ? (
                                    <Form.Select
                                      id={"andorselect" + idx}
                                      style={{
                                        height: "100%",
                                        backgroundColor: "DarkGray",
                                        color: "#8c8c8c",
                                      }}
                                      onChange={(e) => {
                                        if (e.target.value == 1)
                                          booleanQueryParts[idx] = true;
                                        else {
                                          booleanQueryParts[idx] = false;
                                        }
                                        toggler();
                                      }}
                                    >
                                      <option value="0">or</option>
                                      <option value="1">and</option>
                                    </Form.Select>
                                  ) : null}
                                </Col>
                                <Col
                                  xs={3}
                                  style={{
                                    fontSize: "14px",
                                    color: "DarkGray",
                                  }}
                                >
                                  {val} {percentQueryParts[idx]} %
                                </Col>
                                <Col xs={5}>
                                  <Form.Range
                                    onChange={(e) => {
                                      percentQueryParts[idx] = e.target.value;
                                      toggler();
                                    }}
                                  />
                                </Col>
                                <Col xs={1}> </Col>
                              </Row>
                            );
                          })}
                          <Row style={{ height: "2vh" }}> </Row>
                          {queryParts[0] ? (
                            <Row>
                              <Col xs={12} align="center">
                                <Button
                                  id="queryButton"
                                  style={{
                                    borderColor: "black",
                                    borderRadius: "5px",
                                    backgroundColor: "#006622",
                                    color: "DarkGray",
                                  }}
                                  variant="primary"
                                  onClick={(e) => {
                                    window.setQueryLayers(
                                      e,
                                      percentQueryParts,
                                      booleanQueryParts,
                                      queryParts
                                    );
                                  }}
                                >
                                  Query
                                </Button>
                              </Col>
                            </Row>
                          ) : null}
                          <Row style={{ height: "4vh" }}> </Row>

                          {percentQueryParts[0] && queryResults.length !== 0 ? (
                            <React.Fragment>
                              <Row>
                                <Col xs={1}> </Col>
                                <Col
                                  xs={2}
                                  align="center"
                                  style={{
                                    color: "#8c8c8c",
                                    backgroundColor: "#ebebeb",
                                    borderBottom: "solid 2px black",
                                  }}
                                >
                                  {" "}
                                  #{" "}
                                </Col>
                                <Col
                                  xs={4}
                                  align="center"
                                  style={{
                                    textDecoration: "underline",
                                    color: "#8c8c8c",
                                    backgroundColor: "#ebebeb",
                                    borderBottom: "solid 2px black",
                                  }}
                                >
                                  {" "}
                                  {window.levelZeroForQueries
                                    ? "Country"
                                    : "Region"}{" "}
                                </Col>
                                <Col
                                  xs={4}
                                  align="center"
                                  style={{
                                    textDecoration: "underline",
                                    color: "#8c8c8c",
                                    backgroundColor: "#ebebeb",
                                    borderBottom: "solid 2px black",
                                  }}
                                >
                                  {" "}
                                  {epcList.slice(0, epcList.length - 2)}
                                </Col>
                                <Col xs={1}> </Col>
                              </Row>

                              {queryResults.map((r, idx) => {
                                return (
                                  <Row>
                                    <Col xs={1}></Col>
                                    <Col
                                      xs={2}
                                      style={{
                                        textAlign: "center",
                                        color: "#8c8c8c",
                                        zIndex: 20000,
                                        backgroundColor:
                                          idx % 2 === 0 ? "#d9d9d9" : "#ebebeb",
                                      }}
                                    >
                                      {" "}
                                      {idx + 1}.{" "}
                                    </Col>
                                    <Col
                                      xs={4}
                                      align="center"
                                      style={{
                                        color: "#8c8c8c",
                                        borderRight: "solid 2px",
                                        backgroundColor:
                                          idx % 2 === 0 ? "#ebebeb" : "#d9d9d9",
                                        borderRightColor:
                                          idx % 2 === 0
                                            ? "#404040"
                                            : "DarkGray",
                                      }}
                                    >
                                      {" "}
                                      {r[0]}{" "}
                                    </Col>
                                    <Col
                                      xs={4}
                                      align="center"
                                      style={{
                                        color: "#8c8c8c",
                                        backgroundColor:
                                          idx % 2 === 0 ? "#d9d9d9" : "#ebebeb",
                                      }}
                                    >
                                      {" "}
                                      {percents(r).slice(
                                        0,
                                        percents(r).length - 2
                                      )}
                                    </Col>
                                    <Col xs={1}></Col>
                                  </Row>
                                );
                              })}
                              <Row>
                                <Col xs={1}> </Col>
                                <Col
                                  xs={10}
                                  style={{ borderTop: "3px solid #001a09" }}
                                ></Col>
                                <Col xs={1}> </Col>
                              </Row>
                            </React.Fragment>
                          ) : null}
                          <Row style={{ height: "4vh" }}> </Row>
                        </Container>
                      </Container>
                    </Col>
                  ) : null}
                  {openDownloadsFlag ? (
                    <Col
                      xs={{ order: 1, span: 3 }}
                      style={{
                        zIndex: 50000,
                        borderLeft: "solid 4px #404040",
                        background: "linear-gradient(45deg, #cccccc, #ebebeb)",
                        padding: 0,
                        overflowY: "auto",
                        overflowX: "hidden",
                        height: "100%",
                        margin: 0,
                      }}
                    >
                      <Container fluid style={{ padding: 0, height: "0px" }}>
                        <Row>
                          <Col xs={10} align="center"></Col>
                          <Col xs={2} align="center">
                            {" "}
                            <CloseButton
                              onClick={() => {
                                setOpenDownloadsFlag(false);

                                setTimeout(() => {
                                  mapstate.invalidateSize(true);
                                }, 0);
                              }}
                            />{" "}
                          </Col>
                        </Row>
                        <Row style={{ height: "5vh" }}> </Row>
                        <Row style={{ margin: "1rem 0" }}>
                          <Col
                            xs={4}
                            style={{ textAlign: "center", color: "DarkGray" }}
                          >
                            {" "}
                            NUTS Level 0
                            <br />
                            <OverlayTrigger
                              placement={"bottom"}
                              overlay={
                                <Tooltip
                                  id={`tooltip-1`}
                                  style={{ zIndex: 100000 }}
                                >
                                  <strong>Copy to clipboard</strong>
                                </Tooltip>
                              }
                            >
                              <button
                                className="downloadButton"
                                onClick={() => {
                                  navigator.clipboard.writeText(
                                    `https://${URL}/getWFS_NUTSLevel/0`
                                  );
                                }}
                              >
                                <i class="fa fa-download"></i>
                              </button>
                            </OverlayTrigger>
                          </Col>
                          <Col xs={8} style={{ fontSize: "12px" }}>
                            {" "}
                            <span className="downloadLink">
                              {" "}
                              <a
                                target="_blank"
                                href={`https://${URL}/getWFS_NUTSLevel/0`}
                              >
                                {" "}
                                https://{URL}
                                /getWFS_NUTSLevel/0{" "}
                              </a>
                            </span>
                          </Col>
                        </Row>
                        <Dropdown.Divider />
                        <Row style={{ margin: "1rem 0" }}>
                          <Col
                            xs={4}
                            style={{ textAlign: "center", color: "DarkGray" }}
                          >
                            {" "}
                            NUTS Level 1
                            <br />
                            <OverlayTrigger
                              placement={"bottom"}
                              overlay={
                                <Tooltip
                                  id={`tooltip-1`}
                                  style={{ zIndex: 100000 }}
                                >
                                  <strong>Copy to clipboard</strong>
                                </Tooltip>
                              }
                            >
                              <button
                                className="downloadButton"
                                onClick={() => {
                                  navigator.clipboard.writeText(
                                    `https://${URL}/getWFS_NUTSLevel/1`
                                  );
                                }}
                              >
                                <i class="fa fa-download"></i>
                              </button>
                            </OverlayTrigger>
                          </Col>
                          <Col xs={8} style={{ fontSize: "12px" }}>
                            <span className="downloadLink">
                              {" "}
                              <a
                                target="_blank"
                                href={`https://${URL}/getWFS_NUTSLevel/1`}
                              >
                                {" "}
                                https://{URL}/getWFS_NUTSLevel/1
                              </a>
                            </span>
                          </Col>
                        </Row>
                        <Dropdown.Divider />
                        <Row style={{ margin: "1rem 0" }}>
                          <Col
                            xs={4}
                            style={{ textAlign: "center", color: "DarkGray" }}
                          >
                            {" "}
                            NUTS Level 2
                            <br />
                            <OverlayTrigger
                              placement={"bottom"}
                              overlay={
                                <Tooltip
                                  id={`tooltip-1`}
                                  style={{ zIndex: 100000 }}
                                >
                                  <strong>Copy to clipboard</strong>
                                </Tooltip>
                              }
                            >
                              <button
                                className="downloadButton"
                                onClick={() => {
                                  navigator.clipboard.writeText(
                                    `https://${URL}/getWFS_NUTSLevel/2`
                                  );
                                }}
                              >
                                <i class="fa fa-download"></i>
                              </button>
                            </OverlayTrigger>
                          </Col>
                          <Col xs={8} style={{ fontSize: "12px" }}>
                            {" "}
                            <span className="downloadLink">
                              {" "}
                              <a
                                target="_blank"
                                href={`https://${URL}/getWFS_NUTSLevel/2`}
                              >
                                {" "}
                                https://{URL}
                                /getWFS_NUTSLevel/2{" "}
                              </a>{" "}
                            </span>
                          </Col>
                        </Row>
                        <Dropdown.Divider />
                        <Row style={{ margin: "1rem 0" }}>
                          <Col
                            xs={4}
                            style={{ textAlign: "center", color: "DarkGray" }}
                          >
                            {" "}
                            NUTS Level 3
                            <br />
                            <OverlayTrigger
                              placement={"bottom"}
                              overlay={
                                <Tooltip
                                  id={`tooltip-1`}
                                  style={{ zIndex: 100000 }}
                                >
                                  <strong>Copy to clipboard</strong>
                                </Tooltip>
                              }
                            >
                              <button
                                className="downloadButton"
                                onClick={() => {
                                  navigator.clipboard.writeText(
                                    `https://${URL}/getWFS_NUTSLevel/3`
                                  );
                                }}
                              >
                                <i class="fa fa-download"></i>
                              </button>
                            </OverlayTrigger>
                          </Col>
                          <Col xs={8} style={{ fontSize: "12px" }}>
                            {" "}
                            <span className="downloadLink">
                              {" "}
                              <a
                                target="_blank"
                                href={`https://${URL}/getWFS_NUTSLevel/3`}
                              >
                                {" "}
                                https://{URL}
                                /getWFS_NUTSLevel/3{" "}
                              </a>
                            </span>
                          </Col>
                        </Row>
                      </Container>
                    </Col>
                  ) : null}
                </React.Fragment>
              )}
            </Row>
          </Col>
          <Col
            xs="auto"
            style={{ width: "10px", backgroundColor: "Fuchsia", padding: 0 }}
          >
            {" "}
          </Col>
        </Row>
      </Container>

      {chartVisible ? (
        <div
          id="chartcontainer"
          style={{
            position: "absolute",
            right: "0px",
            bottom: "0px",
            zIndex: 10000,
            width: "20vw",
            height: "50vh",
            backgroundColor: "#cccccc",
          }}
        >
          <div
            style={{
              height: "10%",
              textAlign: "center",
              backgroundColor: "#b3b3b3",
            }}
          >
            <Container>
              <Row>
                <Col xs={2}> </Col>
                <Col
                  xs={8}
                  style={{
                    lineHeight: "200%",
                    textDecoration: "underline",
                    color: "#4d4d4d",
                    fontWeight: 900,
                  }}
                >
                  {"dEPC"}
                </Col>
                <Col xs={2}>
                  <CloseButton
                    variant="white"
                    onClick={() => {
                      let previous =
                        window.queryResults && window.previousLayer
                          ? window.queryResults.filter(
                              (x) =>
                                x[0] ===
                                window.previousLayer.feature.properties
                                  .name_latn
                            )
                          : [];

                      if (previous.length > 0) {
                        window.previousLayer &&
                          window.previousLayer.setStyle({
                            fillColor: "#404040",
                            //fillOpacity: 0.8,
                            //color: "#0000cc",
                          });
                        window.previousLayer &&
                          window.previousLayer.bringToFront();
                      } else {
                        window.previousLayer &&
                          window.previousLayer.setStyle({
                            //color: "#3388ff",
                            fillColor: "#bababa",
                            //fillOpacity: 0.2,
                          });
                      }
                      window.previousLayer = null;
                      setChartVisible(false);
                    }}
                  />
                </Col>
              </Row>
            </Container>
          </div>
          <div
            style={{
              position: "relative",
              height: "73%",
              width: "83%",
              margin: "10%",
            }}
          >
            <Doughnut
              typeAnumber={typeAnumber}
              typeBnumber={typeBnumber}
              typeCnumber={typeCnumber}
              typeDnumber={typeDnumber}
              typeEnumber={typeEnumber}
              typeFnumber={typeFnumber}
              doughnutTitle={doughnutTitle}
            />
          </div>
        </div>
      ) : null}

      {barChartVisible ? (
        <div
          id="chartcontainer2"
          style={{
            position: "absolute",
            right: "0px",
            bottom: "0px",
            zIndex: 10000,
            width: "24vw",
            height: "40vh",

            backgroundColor: "#cccccc",
          }}
        >
          <div
            style={{
              height: "12%",
              textAlign: "center",
              backgroundColor: "#b3b3b3",
            }}
          >
            <Container>
              <Row>
                <Col xs={2}> </Col>
                <Col
                  xs={8}
                  style={{
                    lineHeight: "200%",
                    textDecoration: "underline",
                    color: "#4d4d4d",
                    fontWeight: 900,
                  }}
                >
                  {"dEPC"}
                </Col>
                <Col xs={2}>
                  <CloseButton
                    variant="white"
                    onClick={() => {
                      let previousC =
                        window.queryResults && window.comparedLayer
                          ? window.queryResults.filter(
                              (x) =>
                                x[0] ===
                                window.comparedLayer.feature.properties
                                  .name_latn
                            )
                          : [];
                      let previous =
                        window.queryResults && window.previousLayer
                          ? window.queryResults.filter(
                              (x) =>
                                x[0] ===
                                window.previousLayer.feature.properties
                                  .name_latn
                            )
                          : [];

                      if (previous.length > 0) {
                        window.previousLayer &&
                          window.previousLayer.setStyle({
                            fillColor: "#404040",
                            //fillOpacity: 0.8,
                            //color: "#0000cc",
                          });
                        window.previousLayer &&
                          window.previousLayer.bringToFront();
                      } else {
                        window.previousLayer &&
                          window.previousLayer.setStyle({
                            //color: "#3388ff",
                            fillColor: "#bababa",
                            //fillOpacity: 0.2,
                          });
                      }

                      if (previousC.length > 0) {
                        window.comparedLayer &&
                          window.comparedLayer.setStyle({
                            fillColor: "#404040",
                            //fillOpacity: 0.8,
                            //color: "#0000cc",
                          });
                        window.comparedLayer &&
                          window.comparedLayer.bringToFront();
                      } else {
                        window.comparedLayer &&
                          window.comparedLayer.setStyle({
                            //color: "#3388ff",
                            fillColor: "#bababa",
                            //fillOpacity: 0.2,
                          });
                      }

                      window.previousLayer = null;
                      window.comparedLayer = null;
                      setBarChartVisible(false);
                      //window.theBtn.classList.remove("activeComparison");

                      stateRef.current = false;
                      setMainCountry("");
                      setMainA(0);
                      setMainB(0);
                      setMainC(0);
                      setMainD(0);
                      setMainE(0);
                      setMainF(0);
                      setComparedCountry("");
                      setComparedA(0);
                      setComparedB(0);
                      setComparedC(0);
                      setComparedD(0);
                      setComparedE(0);
                      setComparedF(0);
                    }}
                  />
                </Col>
              </Row>
            </Container>
          </div>
          <div
            style={{
              position: "absolute",
              height: "73%",
              width: "83%",
              margin: "10%",
            }}
          >
            <Bar
              mainA={mainA}
              mainB={mainB}
              mainC={mainC}
              mainD={mainD}
              mainE={mainE}
              mainF={mainF}
              comparedA={comparedA}
              comparedB={comparedB}
              comparedC={comparedC}
              comparedD={comparedD}
              comparedE={comparedE}
              comparedF={comparedF}
              mainCountry={mainCountry}
              comparedCountry={comparedCountry}
            />
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default MapL;
